import { IsString } from 'class-validator';

export class NomenclatureTypeRestoreRequest {
    @IsString()
    public uuid: string;

    constructor(data?: Partial<NomenclatureTypeRestoreRequest>) {
        this.uuid = data?.uuid;
    }
}
